<section class="incidencia-history-modal">
  <header class="incidencia-history-modal__header">
    <div>
      <span class="incidencia-history-modal__eyebrow">Incidencias QA</span>
      <h2>Historial de asignaciones</h2>
      <p>Consulta los cambios de responsable registrados para esta incidencia.</p>
    </div>

    <button
      type="button"
      mat-icon-button
      class="incidencia-history-modal__close"
      (click)="onCloseClick()"
      aria-label="Cerrar modal"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="incidencia-history-modal__body">
    <div class="incidencia-history-modal__timeline" *ngIf="parameter.dataListaHis?.length; else emptyState">
      <article class="incidencia-history-modal__item" *ngFor="let incidencias of parameter.dataListaHis">
        <div class="incidencia-history-modal__dot"></div>

        <div class="incidencia-history-modal__card">
          <div class="incidencia-history-modal__item-head">
            <strong>{{ incidencias.fecha_creacion }}</strong>
            <span>{{ incidencias.usuarioBean.persona.nombreCompleto }}</span>
          </div>

          <div class="incidencia-history-modal__grid">
            <div class="incidencia-history-modal__meta">
              <span class="incidencia-history-modal__label">Asignado anterior</span>
              <strong>{{ incidencias.nombre_emp_asignado }}</strong>
            </div>

            <div class="incidencia-history-modal__meta">
              <span class="incidencia-history-modal__label">Asignado actual</span>
              <strong>{{ incidencias.nombre_emp_reasignado }}</strong>
            </div>

            <div class="incidencia-history-modal__meta incidencia-history-modal__meta--wide">
              <span class="incidencia-history-modal__label">Asignó</span>
              <strong>{{ incidencias.usuarioBean.persona.nombreCompleto }}</strong>
            </div>

            <mat-form-field appearance="outline" class="incidencia-history-modal__field incidencia-history-modal__meta--wide">
              <mat-label>Motivo</mat-label>
              <textarea
                matInput
                aria-label="Motivo"
                readonly
                rows="4"
                [ngModel]="incidencias.descripcion"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </article>
    </div>

    <ng-template #emptyState>
      <p class="incidencia-history-modal__empty">
        No hay historial de asignaciones registrado.
      </p>
    </ng-template>
  </div>
</section>
